import * as THREE from 'three';

/**
 * The 1.70 m reference figure of a test drive (ADR-048, spec §3): a grown-up beside the item, so its
 * real size reads at a glance -- the T. rex against a person, the skeleton beside one. Drawn like the
 * model viewer's 1.5 m figure (render/models/viewer-scene.ts), never pickable: it is no lesson object.
 */
export const REFERENCE_FIGURE_HEIGHT = 1.7;

export function makeReferenceFigure(
  pos: readonly [number, number, number] = [0, 0, 0],
  height = REFERENCE_FIGURE_HEIGHT,
): THREE.Group {
  const figure = new THREE.Group();
  const material = new THREE.MeshStandardMaterial({ color: 0x7d8fa6, roughness: 0.8 });
  const head = 0.12;
  const radius = 0.17;
  const length = height - 2 * head - 2 * radius - 0.02;
  const body = new THREE.Mesh(new THREE.CapsuleGeometry(radius, length, 6, 16), material);
  body.position.y = (height - 2 * head - 0.02) / 2;
  const top = new THREE.Mesh(new THREE.SphereGeometry(head, 20, 14), material);
  top.position.y = height - head;
  for (const part of [body, top]) {
    part.castShadow = true;
    part.raycast = () => {};
    figure.add(part);
  }
  figure.name = 'reference-figure';
  figure.userData['pickable'] = false;
  figure.position.set(pos[0], pos[1], pos[2]);
  return figure;
}

/** Takes the figure off its scene and frees what it drew. */
export function disposeFigure(figure: THREE.Object3D): void {
  figure.removeFromParent();
  figure.traverse((node) => {
    if (!(node instanceof THREE.Mesh)) return;
    (node.geometry as THREE.BufferGeometry).dispose();
    const material: THREE.Material | THREE.Material[] = node.material as
      THREE.Material | THREE.Material[];
    for (const each of Array.isArray(material) ? material : [material]) each.dispose();
  });
}
